import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';

const SellerDashboard = () => {
  const { user, isAuthenticated } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/account');
      return;
    }

    if (user?.role !== 'seller') {
      navigate('/');
      return;
    }

    if (user?.sellerStatus !== 'approved') {
      navigate('/seller/application');
      return;
    }
  }, [isAuthenticated, user, navigate]);

  if (!isAuthenticated || user?.role !== 'seller' || user?.sellerStatus !== 'approved') {
    return null;
  }

  return (
    <section className="seller-dashboard py-80">
      <div className="container container-lg">
        <div className="row">
          <div className="col-12">
            <div className="bg-white rounded-16 p-40 shadow-sm">
              <h1 className="mb-24">Welcome, {user.username}!</h1>
              
              <div className="alert alert-success mb-32">
                <i className="ph ph-storefront me-2"></i>
                <strong>{user.storeName}</strong> - Your seller account is active!
              </div>

              <div className="row g-4">
                <div className="col-md-4">
                  <div className="bg-light p-24 rounded-12 text-center">
                    <i className="ph ph-package fs-1 text-main-600 mb-16"></i>
                    <h5>0</h5>
                    <p className="text-gray-500 mb-0">Products</p>
                  </div>
                </div>
                
                <div className="col-md-4">
                  <div className="bg-light p-24 rounded-12 text-center">
                    <i className="ph ph-shopping-cart-simple fs-1 text-main-600 mb-16"></i>
                    <h5>0</h5>
                    <p className="text-gray-500 mb-0">Orders</p>
                  </div>
                </div>
                
                <div className="col-md-4">
                  <div className="bg-light p-24 rounded-12 text-center">
                    <i className="ph ph-currency-circle-dollar fs-1 text-main-600 mb-16"></i>
                    <h5>₹0</h5>
                    <p className="text-gray-500 mb-0">Today's Earnings</p>
                  </div>
                </div>
              </div>

              <div className="mt-40">
                <h5 className="mb-20">Quick Actions</h5>
                <div className="d-flex gap-16 flex-wrap">
                  <button className="btn btn-main">
                    <i className="ph ph-plus-circle me-2"></i>
                    Add New Product
                  </button>
                  <button className="btn btn-outline-main">
                    <i className="ph ph-package me-2"></i>
                    Manage Products
                  </button>
                  <button className="btn btn-outline-main">
                    <i className="ph ph-clock me-2"></i>
                    View Orders
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SellerDashboard;